import React from "react";
import PropTypes from "prop-types";
import { Icon } from "@qgiv/core-react";
import { Button } from "@qgiv/core-donor";

const AddAdditionalParticipantButton = ({
    addParticipantButtonLabel,
    additionalParticipantsDisabled,
    isCms,
    Is_Nfp,
    setFieldValue,
    submitForm,
    handleFormSubmitWithEmailValidation = () => {},
}) => (
    <Button
        type="button"
        btnStyle="secondary"
        disabled={additionalParticipantsDisabled}
        name="Save_And_Add_Another_Registration"
        id="Save_And_Add_Another_Registration"
        classes={additionalParticipantsDisabled ? "-disabled" : undefined}
        onClick={(e) => {
            // we do not want to submit anything in cms view
            if (isCms) {
                return;
            }

            if (Is_Nfp) {
                // Nfp's bypass email validation
                // but we still need to set "Add_New_Registration": true
                setFieldValue("Add_New_Registration", true);
                submitForm();
            } else {
                handleFormSubmitWithEmailValidation(e, {
                    addNewRegistration: true,
                });
            }
        }}
    >
        <span className="registration-page-submit__icon">
            <Icon type="FontAwesome" glyph="user-plus" />
        </span>
        {addParticipantButtonLabel}
    </Button>
);

AddAdditionalParticipantButton.propTypes = {
    addParticipantButtonLabel: PropTypes.string.isRequired,
    additionalParticipantsDisabled: PropTypes.bool.isRequired,
    isCms: PropTypes.bool.isRequired,
    Is_Nfp: PropTypes.bool.isRequired,
    handleFormSubmitWithEmailValidation: PropTypes.func,
    setFieldValue: PropTypes.func.isRequired,
    submitForm: PropTypes.func.isRequired,
};

export default AddAdditionalParticipantButton;
